import React from 'react';
import {
  CircularProgress,
  Typography,
  Container,
  makeStyles,
  Theme,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '200px',
  },
}));

interface Props {
  message: string;
}

const LoadingProgress: React.FunctionComponent<Props> = ({ message }) => {
  const classes = useStyles();
  return (
    <Container className={classes.root}>
      <CircularProgress />
      <Typography>{message}</Typography>
    </Container>
  );
};

export default LoadingProgress;
